var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#8247e4;}.cls-4{fill:#8b5fed;}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "binancecoin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-3",
    width: 30,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    className: "cls-4",
    d: "M0,7A7,7,0,0,1,7,0h6.66a16.54,16.54,0,0,1,.82,5.17A16.55,16.55,0,0,1,0,21.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "YMZX6w.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25,20.21l0,.18a1.24,1.24,0,0,1-.61.83l-2.81,1.63-1.4.81a.79.79,0,0,1-.45.13H19.3a.71.71,0,0,1-.4-.11l-3.2-1.86-1-.59A1.28,1.28,0,0,1,14,20.09V18.43a.08.08,0,0,1,0-.07L16,17.25h0V18.9A1.27,1.27,0,0,0,16.67,20c.74.43,1.47.87,2.22,1.28a1.26,1.26,0,0,0,1.31,0L22.33,20a1.28,1.28,0,0,0,.64-.89,1.24,1.24,0,0,0,0-.27V16.35a1.3,1.3,0,0,0-.7-1.21c-.72-.41-1.43-.84-2.15-1.24a1.23,1.23,0,0,0-1.32,0L14.6,16.34c-1.15.67-2.3,1.35-3.46,2a1.28,1.28,0,0,1-1.36,0l-3.63-2.1c-.2-.12-.41-.23-.61-.36A1.3,1.3,0,0,1,5,15a1.15,1.15,0,0,1,0-.19c0-1.63,0-3.27,0-4.9a1.11,1.11,0,0,1,.55-1c.3-.19.62-.36.93-.54l3.39-2c.1-.06.21-.09.31-.14h.78l.25.12,1.28.76c1,.56,1.92,1.12,2.87,1.69A1.24,1.24,0,0,1,16,9.89c0,.58,0,1.16,0,1.74a.07.07,0,0,1,0,.06L14,12.79l0,0V11.15A1.09,1.09,0,0,0,14,11a1.27,1.27,0,0,0-.6-1c-.75-.45-1.49-.91-2.24-1.35a1.28,1.28,0,0,0-1.32,0L7.62,9.92A1.27,1.27,0,0,0,7,11.08v2.55a1,1,0,0,0,0,.17,1.23,1.23,0,0,0,.6.95L9.6,16a2.47,2.47,0,0,0,.46.23,1.27,1.27,0,0,0,1.06-.11l1.58-.95c.63-.37,1.25-.76,1.9-1.11.46-.25.93-.5,1.39-.77,1-.56,1.92-1.14,2.89-1.7a1.26,1.26,0,0,1,1.31,0L24.38,14a1.32,1.32,0,0,1,.62.79A2.23,2.23,0,0,1,25,15Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.be9e13bfaf257123bb730d2f3e9e574a.svg";
export { ForwardRef as ReactComponent };